import { Link } from 'react-router-dom';
import type { Video } from '@/types/video';
import { formatViews } from '@/utils/format';

interface VideoCardProps {
  video: Video;
  showCategory?: boolean;
}

export default function VideoCard({ video, showCategory = true }: VideoCardProps) {
  return (
    <Link to={`/video/${video.id}`} className="group block">
      <div className="relative w-full aspect-video overflow-hidden rounded-lg bg-background-100 border border-background-200/60">
        <img
          src={video.cover}
          alt={video.title}
          title={`${video.title} - 啪啪视频高清在线播放`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-background-950/0 group-hover:bg-background-950/40 transition-colors duration-300 flex items-center justify-center">
          <span className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-500 text-background-50 opacity-0 scale-90 group-hover:opacity-100 group-hover:scale-100 transition-all duration-300">
            <i className="ri-play-fill text-2xl" />
          </span>
        </div>
        <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-background-950/70 text-accent-400 text-xs font-semibold backdrop-blur">
          <i className="ri-star-fill mr-1 text-[10px]" />
          {video.rating.toFixed(1)}
        </span>
        <span className="absolute bottom-2 right-2 px-2 py-0.5 rounded-md bg-background-950/75 text-foreground-900 text-xs font-medium backdrop-blur">
          {video.duration}
        </span>
      </div>
      <h3 className="mt-3 text-sm font-medium text-foreground-900 leading-snug line-clamp-1 group-hover:text-accent-500 transition-colors">
        {video.title}
      </h3>
      <p className="mt-1 text-xs text-foreground-600 line-clamp-1">
        {showCategory && <span>{video.categoryName} · </span>}
        {formatViews(video.views)}次播放
      </p>
    </Link>
  );
}